import { useEffect, useRef, useState } from "react";
import "./App.css";

function VolumeControl({ videoRef, volume, setVolume, muted, setMuted }) {
  const [hovering, setHovering] = useState(false);

  const handleSlider = (e) => {
    const val = Number(e.target.value);
    setVolume(val);
    setMuted(val === 0);
    if (videoRef.current) {
      videoRef.current.volume = val;
      videoRef.current.muted = val === 0;
    }
  };

  const toggleMute = () => {
    const newMuted = !muted;
    setMuted(newMuted);
    if (videoRef.current) {
      videoRef.current.muted = newMuted;
      if (!newMuted && volume === 0) {
        setVolume(1);
        videoRef.current.volume = 1;
      }
    }
  };

  return (
    <div
      className={`volume-control ${hovering ? "volume-control-open" : ""}`}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
    >
      <button
        type="button"
        className="volume-icon"
        onClick={toggleMute}
        aria-label="toggle volume"
      >
        {muted || volume === 0 ? (
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M11 5 6 9H2v6h4l5 4V5Z" />
            <line x1="23" y1="9" x2="17" y2="15" />
            <line x1="17" y1="9" x2="23" y2="15" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M11 5 6 9H2v6h4l5 4V5Z" />
            <path d="M15.5 8.5a5 5 0 0 1 0 7" />
            <path d="M18.5 6a9 9 0 0 1 0 12" />
          </svg>
        )}
      </button>
      <div className="volume-slider-wrap">
        <input
          type="range"
          className="volume-slider"
          min="0"
          max="1"
          step="0.01"
          value={muted ? 0 : volume}
          onChange={handleSlider}
        />
      </div>
    </div>
  );
}

function PolicyPage({ onBack }) {
  return (
    <div className="policy-wrap">
      <div className="policy-card">
        <button className="policy-back" onClick={onBack}>
          &larr; back
        </button>
        <h2>Privacy Policy</h2>
        <p>
          SaltyPro is a Chrome extension for SaltyBet. It does not collect,
          store, or transmit any personal data.
        </p>
        <p>
          If that ever changes,
          this page will be updated first.
        </p>
      </div>
    </div>
  );
}

function App() {
  const videoRef = useRef(null);
  const [volume, setVolume] = useState(0.45);
  const [muted, setMuted] = useState(true);
  const [entered, setEntered] = useState(false);
  const [fading, setFading] = useState(false);
  const [revealed, setRevealed] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.volume = volume;
      videoRef.current.pause();
    }
  }, [volume]);

  const handleEnter = () => {
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.volume = volume;
      videoRef.current.play();
    }
    setMuted(false);
    setFading(true);
    setTimeout(() => {
      setRevealed(true);
    }, 250);
  };

  const handleGateTransitionEnd = () => {
    if (fading) {
      setEntered(true);
    }
  };

  if (showPolicy) {
    return (
      <div className="app-root">
        <video
          ref={videoRef}
          id="bg-video"
          loop
          muted
          autoPlay
          playsInline
          src="/bg.mp4"
        />
        <PolicyPage onBack={() => setShowPolicy(false)} />
      </div>
    );
  }

  return (
    <div className="app-root">
      <video
        ref={videoRef}
        id="bg-video"
        loop
        muted
        playsInline
        src="/bg.mp4"
      />

      {!entered && (
        <div
          className={`enter-gate ${fading ? "enter-gate-fade" : ""}`}
          onClick={handleEnter}
          onTransitionEnd={handleGateTransitionEnd}
        >
          <span className="enter-text">click to enter</span>
        </div>
      )}

      {entered && (
        <VolumeControl
          videoRef={videoRef}
          volume={volume}
          setVolume={setVolume}
          muted={muted}
          setMuted={setMuted}
        />
      )}

      <div className="wrap">
        <div className={`card ${revealed ? "revealed" : ""}`}>
          <p className="bio">
            SaltyPro is a Chrome extension for SaltyBet that helps
            you place smarter bets and make money. It runs on the SaltyBoy
            API with an improved UI and extra features on top. 100+ people
            are using it already.
          </p>

          <div className="links">
            <a
              className="link-row"
              href="https://lxzy.my/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="link-name">Main Website</span>
              <span className="arrow">&#8594;</span>
            </a>

            <a
              className="link-row"
              href="https://chromewebstore.google.com/detail/saltypro/eocgcmccjmhiheelnmpkgohneocaongn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="link-name">SaltyPro</span>
              <span className="arrow">&#8594;</span>
            </a>
          </div>

          <button className="policy-link" onClick={() => setShowPolicy(true)}>
            privacy policy
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;